export const resolveRoute = (baseUrl) => `${baseUrl}/shipment/:fulfillmentPlanId`;
